export default {
	title: "Personligt Center",
	subTitle: ["Profil", "Säkerhet", "System"],
	menu: ["Ändra personlig information", "Användarnamn", "Uppdatera lösenord", "Uppdatera transaktionslösenord"],
	updatePassword: {
		form: {
			label: ["Gamla lösenord", "Nytt lösenord", "Bekräfta nytt lösenord"]
		}
	},
	updateTransactionPassword: {
		form: {
			label: ["Gamla lösenord", "Nytt lösenord", "Bekräfta nytt lösenord"]
		}
	}
};
